import { render } from "./ProyectoView.vue?vue&type=template&id=3941d0de&scoped=true"
import script from "./ProyectoView.vue?vue&type=script&lang=js"
export * from "./ProyectoView.vue?vue&type=script&lang=js"

import "./ProyectoView.vue?vue&type=style&index=0&id=3941d0de&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3941d0de"]])

export default __exports__